import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["title", "helpMessage", "notSureLabel", "months", "chooseMonthTitle", "dayCountTitle", "countDaysTemplate", "countDayTemplate", "initData", "celsiusLabel", "fahrenheitLabel", "onDataChange"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './TravelPlan.css';
import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import Toggle from '../atoms/Toggle/Toggle';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import Flatpickr from 'react-flatpickr';
import useIsWidthLess from '../../utils/hooks/useIsWidthLess';
import ChooseMonth from '../ChooseMonth/ChooseMonth';
import Counter from '../atoms/Counter/Counter';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import { get } from '../../utils';
import { MILLISECONDS_IN_DAY } from '../IdentifyTravelers/constants';
var DAYS_LIMIT = 14;
var TravelPlan = function TravelPlan(_ref) {
  var title = _ref.title,
    helpMessage = _ref.helpMessage,
    notSureLabel = _ref.notSureLabel,
    months = _ref.months,
    chooseMonthTitle = _ref.chooseMonthTitle,
    dayCountTitle = _ref.dayCountTitle,
    countDaysTemplate = _ref.countDaysTemplate,
    countDayTemplate = _ref.countDayTemplate,
    initData = _ref.initData,
    celsiusLabel = _ref.celsiusLabel,
    fahrenheitLabel = _ref.fahrenheitLabel,
    onDataChange = _ref.onDataChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var currentLang = get(sitecoreContext, 'language').toLowerCase();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(initData.notSure),
    _useState2 = _slicedToArray(_useState, 2),
    notSureOfTravelDates = _useState2[0],
    setNotSureOfTravelDates = _useState2[1];
  var isCompactCalendar = useIsWidthLess(1090);
  var _useState3 = useState(initData.selectedMonth),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedMonthId = _useState4[0],
    setSelectedMonthId = _useState4[1];
  var _useState5 = useState(initData.dayCount),
    _useState6 = _slicedToArray(_useState5, 2),
    countOfDays = _useState6[0],
    setCountOfDays = _useState6[1];
  var _useState7 = useState(initData.period),
    _useState8 = _slicedToArray(_useState7, 2),
    dates = _useState8[0],
    setDates = _useState8[1];
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dateToDisable = _React$useState2[0],
    setDateToDisable = _React$useState2[1];
  var fpInstance = useRef(null);
  var currentLocale = useMemo(function () {
    var langHash = {
      ar: Arabic,
      ru: Russian,
      cs: Czech,
      nl: Dutch,
      fi: Finnish,
      de: German,
      ja: Japanese,
      no: Norwegian,
      pt: Portuguese,
      sv: Swedish,
      zh: Mandarin,
      da: Danish,
      fr: French,
      it: Italian,
      ko: Korean,
      pl: Polish,
      ro: Romanian,
      es: Spanish,
      uk: Ukrainian,
      tr: Turkish
    };
    return langHash[currentLang];
  }, [currentLang]);
  var countTemplates = countOfDays === 1 ? countDayTemplate : countDaysTemplate;
  var onMonthClick = function onMonthClick(monthId) {
    setSelectedMonthId(monthId);
    props.onMonthClick && props.onMonthClick(monthId);
  };
  useEffect(function () {
    if (notSureOfTravelDates === false) {
      setCountOfDays(1);
      setSelectedMonthId("");
    } else {
      setDates([]);
      setDateToDisable('');
    }
  }, [notSureOfTravelDates]);
  var onDateChange = function onDateChange(dates) {
    setDates(dates);
    if (dates && dates.length !== 0) {
      var date0Temp = new Date(dates[0]);
      setDateToDisable(date0Temp);
    }
    if (fpInstance.current) {
      if (dates.length === 1) {
        fpInstance.current.flatpickr.set({
          enable: [{
            from: new Date(dates[0].getTime() - MILLISECONDS_IN_DAY * 13),
            to: new Date(dates[0].getTime() + MILLISECONDS_IN_DAY * 13)
          }]
        });
      } else {
        fpInstance.current.flatpickr.set({
          enable: [function () {
            return true;
          }]
        });
      }
    }
    props.onDateChange && props.onDateChange(dates);
  };
  var onNotSureToggle = function onNotSureToggle(value) {
    props.onNotSureToggle && props.onNotSureToggle(value);
    setNotSureOfTravelDates(value);
  };
  var onCounterChange = function onCounterChange(value) {
    setCountOfDays(value);
    props.onCounterChange && props.onCounterChange(value);
  };
  useEffect(function () {
    onDataChange({
      notSure: notSureOfTravelDates,
      dayCount: countOfDays,
      period: dates,
      selectedMonth: selectedMonthId
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dates, countOfDays, selectedMonthId, notSureOfTravelDates]);
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("h2", {
    className: "travelplan__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "travelplan__below-title-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "travelplan__description"
  }, helpMessage), /*#__PURE__*/React.createElement(Toggle, {
    className: "travelplan__toggle",
    value: notSureOfTravelDates,
    rtl: rtl,
    label: notSureLabel,
    onChange: onNotSureToggle
  })), notSureOfTravelDates ? /*#__PURE__*/React.createElement("div", {
    className: "travelplan__choose-month"
  }, /*#__PURE__*/React.createElement(ChooseMonth, {
    months: months,
    selectedMonthId: selectedMonthId,
    title: chooseMonthTitle,
    onMonthClick: onMonthClick,
    celsiusLabel: celsiusLabel,
    fahrenheitLabel: fahrenheitLabel
  }), /*#__PURE__*/React.createElement("h3", {
    className: "travelplan__day-count-title"
  }, dayCountTitle), /*#__PURE__*/React.createElement(Counter, {
    countTemplate: countTemplates,
    onChange: onCounterChange,
    value: countOfDays,
    limit: DAYS_LIMIT
  })) : /*#__PURE__*/React.createElement("div", {
    className: "travelplan__calendar ".concat("d19knin3", " ", isCompactCalendar ? "travelplan__calendar--compact" : "")
  }, /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fpInstance,
    className: "travelplan__flatpickr",
    onChange: onDateChange,
    options: {
      inline: true,
      showMonths: isCompactCalendar ? 1 : 2,
      mode: 'range',
      minDate: dateToDisable || 'today',
      monthSelectorType: "static",
      defaultDate: initData.period,
      locale: currentLocale || 'en',
      nextArrow: "\n                  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9.428\" height=\"16.768\" viewBox=\"0 0 9.428 16.768\">\n                    <path d=\"M8.142,0a1.127,1.127,0,0,0-.749.308L.344,7.076a1.131,1.131,0,0,0,1.568,1.63L8.177,2.688l6.264,6.017a1.131,1.131,0,0,0,1.568-1.63L8.961.309A1.127,1.127,0,0,0,8.142,0Z\" transform=\"translate(9.228 0.207) rotate(90)\" stroke-width=\"0.4\"/>\n                  </svg>\n                ",
      prevArrow: "\n                  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9.428\" height=\"16.768\" viewBox=\"0 0 9.428 16.768\">\n                    <path d=\"M8.142,9.018a1.127,1.127,0,0,1-.749-.308L.344,1.943A1.131,1.131,0,0,1,1.913.314L8.177,6.331,14.441.314a1.131,1.131,0,0,1,1.568,1.63L8.961,8.71a1.127,1.127,0,0,1-.819.308Z\" transform=\"translate(9.219 0.207) rotate(90)\" stroke-width=\"0.4\"/>\n                  </svg>\n                "
    }
  })));
};
export default TravelPlan;
var commonStyles = "c1qrnh3l";